module.exports = __webpack_public_path__ + "static/profile-e701694d161d0db54b3642046800e5ea.jpg";